export { default } from 'shared/services/apiService'
